import * as React from "react";

import xlsx from "../Images/picto_xls.png";
import csv from "../Images/picto_csv.png";
import pdf from "../Images/pdf.png";
import doc from "../Images/picto_word.png";
import png from "../Images/picto_image.png";

export const FileExtImg = (fileName) => {
  const fileExt = (fileName || "").split(".").pop();

  switch (fileExt) {
    case "xls":
    case "xlsx":
      return (
        <img
          className="xlsx-file"
          src={xlsx}
          width="30px"
          height="30px"
          alt="file ext icon"
        />
      );

    case "txt":
    case "csv":
      return (
        <img
          className="csv-file"
          src={csv}
          width="30px"
          height="30px"
          alt="file ext icon"
        />
      );

    case "doc":
    case "docx":
      return (
        <img
          className="doc-file"
          src={doc}
          width="30px"
          height="30px"
          alt="file ext icon"
        />
      );

    case "pdf":
      return (
        <img
          className="pdf-file"
          src={pdf}
          width="30px"
          height="30px"
          alt="file ext icon"
        />
      );

    default:
      return (
        <img
          className="png-file"
          src={png}
          width="30px"
          height="30px"
          alt="file ext icon"
        />
      );
  }
};
